import AppConstants from 'general/constants/AppConstants';
import axiosClient from './axiosClient';

const chargePointApi = {
  // lay danh sach tru sac
  getChargePointList: (params) => {
    const url = '/cp';
    return axiosClient.get(url, { params });
  },

  // lay thong tin chi tiet tru sac
  getChargePointDetail: (chargePointId) => {
    const url = `/cp/${chargePointId}`;
    return axiosClient.get(url);
  },

  // kich hoat sac
  activeCharger: (params) => {
    const url = '/cp/activateCharger';
    return axiosClient.post(url, params);
  },

  // thanh toan de kich hoat sac
  activeChargerCashier: (params) => {
    const url = '/cp/activateChargerCashier';
    return axiosClient.post(url, params);
  },

  // kiem tra trang thai thanh toan
  checkPaymentStatus: (params) => {
    const url = '/cp/payment';
    return axiosClient.post(url, params);
  },

  // dung sac
  stopCharger: (chargePointId, chargeConnectorNumber) => {
    const url = '/cp/stopCharger';
    const params = {
      pointId: chargePointId,
      connectorNumber: chargeConnectorNumber,
    };
    return axiosClient.post(url, params);
  },

  // dung sac
  stopChargerByTransactionId: (transactionId) => {
    const url = '/cp/stopCharger';
    const params = {
      transactionId: transactionId,
    };
    return axiosClient.post(url, params);
  },

  // tao tru sac
  createChargePoint: (params) => {
    const url = '/cp/create';
    return axiosClient.post(url, params);
  },

  // cap nhat thong tin tru sac
  updateChargePoint: (chargePointId, params) => {
    const url = `/cp/${chargePointId}`;
    return axiosClient.put(url, params);
  },

  // xoa tru sac
  deleteChargePoint: (chargePointId) => {
    const url = `/cp/${chargePointId}`;
    return axiosClient.delete(url);
  },

  // tao voi sac
  createChargeConnector: (chargePointId, params) => {
    const url = `/cp/${chargePointId}/createConnector`;
    return axiosClient.post(url, params);
  },

  // cap nhat thong tin voi sac
  updateChargeConnector: (chargePointId, chargeConnectorId, params) => {
    const url = `/cp/${chargePointId}/connector/${chargeConnectorId}`;
    return axiosClient.put(url, params);
  },

  // xoa voi sac
  deleteChargeConnector: (chargePointId, chargeConnectorId) => {
    const url = `/cp/${chargePointId}/connector/${chargeConnectorId}`;
    return axiosClient.delete(url);
  },

  // bao loi tru sac
  report: (chargePointId, reason) => {
    const url = `/cp/${chargePointId}`;
    const params = {
      status: AppConstants.chargePointStatus.fault,
      reason: !_.isEmpty(reason) ? reason : null,
    };
    return axiosClient.put(url, params);
  },

  // khoi phuc tru sac
  restore: (chargePointId) => {
    const url = `/cp/${chargePointId}`;
    const params = {
      status: AppConstants.chargePointStatus.available,
    };
    return axiosClient.put(url, params);
  },
};

export default chargePointApi;
